import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getWeatherIcon as getWeatherIconUtil } from '../../utils/weatherUtils';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start !important;
  align-items: flex-start !important;
  padding: 1.5rem 1.5rem 1.5rem 0;
  .title {
    height: 4rem;
    width: 100%;
    padding: 0 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.75rem;
    font-weight: 700;
    color: var(--text-secondary);
  }
  .weatherWeek {
    width: 100%;
    flex-grow: 1;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 0.5rem;
    .weatherDay {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: var(--widget-weather-item-bg);
      // background-color: rgba(255, 255, 255, 0.08);
      border-radius: 1rem;
      border-radius: 0.5rem;
      overflow: hidden;
      &.red {
        .dayTitle .day,
        .date {
          color: var(--widget-status-red);
        }
      }
      &.blue {
        .dayTitle .day,
        .date {
          color: var(--widget-status-blue);
        }
      }
      .dayTitle {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 0.5rem;
        width: 100%;
        color: var(--widget-text-primary);
        padding: 1rem 0 0;
        gap: 0.5rem;

        .day {
          font-size: 1.25rem;
          font-weight: 500;
          color: var(--widget-text-primary);
          width: 100%;
          text-align: center;
        }
        .date {
          font-size: 1.25rem;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .icon {
        flex-grow: 1;
        display: flex;
        align-items: center;
        justify-content: center;

        .no-weather-icon {
          color: var(--widget-text-primary);
        }
      }
      .temp {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        background: var(--widget-weather-item-sub-bg);
        // background-color: rgba(255, 255, 255, 0.05);
        padding: 0.5rem 0;
        border-radius: 0.5rem;
        width: 100%;
        .data-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.125rem;
          font-size: 1.25rem;
          font-weight: 600;
          margin: 0.5rem 0;
          color: var(--text-primary);
          .unit {
            font-size: 1rem;
            font-weight: 500;
            color: var(--text-tertiary);
          }
          .material-symbols-rounded {
            font-size: 1.375rem;
            font-variation-settings: 'FILL' 1, 'wght' 500;
            &.lowest {
              color: var(--widget-status-blue);
            }
            &.highest {
              color: var(--widget-status-red);
            }
          }
        }
      }
    }
  }
  &.medium {
    .weatherWeek {
      padding: 0;
      padding-right: 1rem;
      margin: 1rem 0;
      grid-template-columns: repeat(3, 1fr);
      .weatherDay {
        padding-top: 0.75rem;
        .day {
          display: none;
        }
        .date {
          height: 2.5rem;
          width: 2.5rem;
          font-size: 1.25rem;
        }
        .icon {
          margin: 0;
          padding: 0.5rem;
          padding: 0 0.75rem;
          width: 5rem;
        }
        .temp {
          padding: 0.5rem 0;
          flex-direction: row;
          justify-content: space-between;
          padding-right: 0.5rem;
          padding-left: 0.25rem;
          .data-wrapper {
            margin: 0;
            font-size: 1.0625rem;
            .material-symbols-rounded {
              font-size: 1.125rem;
            }
          }
        }
      }
    }
  }
`;

const getWeatherIconComponent = (weather: string) => {
  return getWeatherIconUtil(weather, 72);
};

interface Props {
  after6Days: IDays[];
  width: 'large' | 'medium';
}

const WeatherWideWeek = ({ after6Days, width }: Props) => {
  const { t } = useTranslation();

  return (
    <Root className={width}>
      {/* <div className='title'>{t('주간 날씨')}</div> */}
      <div className='weatherWeek'>
        {after6Days.map(({ date, day, maxTemp, minTemp, sky }: IDays) => {
          return (
            <div key={date} className={`weatherDay ${day === '토' ? 'blue' : ''} ${day === '일' ? 'red' : ''}`}>
              <div className='dayTitle'>
                <div className='day'>{t(day)}</div>
                <div className='date'>{date}</div>
              </div>
              <div className='icon'>{getWeatherIconComponent(sky)}</div>
              <div className='temp'>
                <div className='data-wrapper'>
                  <span className='material-symbols-rounded lowest'>arrow_downward</span>
                  {minTemp}
                  {/* <span className='unit'>℃</span> */}
                  <span className='unit'>°</span>
                </div>
                <div className='data-wrapper'>
                  <span className='material-symbols-rounded highest'>arrow_upward</span>
                  {maxTemp}
                  {/* <span className='unit'>℃</span> */}
                  <span className='unit'>°</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Root>
  );
};

export default WeatherWideWeek;
